import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionText = () => {
  const getRandomInt = (min, max) =>
    Math.floor(Math.random() * (max - min)) + min;
  let s = Snap('.js-text-anim');
  if (s) {
    const circle = s.circle(1500, 280, 260);
    circle.attr({
      fill: 'transparent',
      stroke: '#ff0050',
      strokeWidth: '2px',
    });
    createTriangle(s, 120, 330, 1200, 350, 30);
  }
  s = Snap('.js-text-team-anim');
  if (s) {
    createTriangle(s, 150, 135, 1200, 110, 30);
  }
  if (document.querySelectorAll('.js-person-anim').length) {
    document.querySelectorAll('.js-person-anim').forEach(element => {
      s = Snap(element);
      createTriangle(
        s,
        getRandomInt(50, 80),
        getRandomInt(0, 359),
        getRandomInt(40, 100),
        getRandomInt(150, 200),
        20,
      );
    });
  }
};

export default sectionText;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-text.js